<template>
    <div>
        <!-- Vue conditional to check if there is any content in document -->
        <div v-if="hasContent">
            <div class="blogposts">
                <!-- Button to edit document in dashboard -->
                <prismic-edit-button :documentId="documentId"/>
                <!-- Template for page title -->
                <div class="container">
                    <div class="blogposts-content">
                        <h1 class="blogposts-title">
                            {{ $prismic.richTextAsPlain(fields.headline) }}
                        </h1>
                        <!-- Template for page description -->
                        <p class="blogposts-description">{{ $prismic.richTextAsPlain(fields.description) }}</p>
                    </div>
                </div>
            </div>
            <!-- Vue reference for blogpost component -->
            <div class="container">
                <blogpost/>
            </div>
        </div>
        <!-- If no content return message -->
        <div v-else class="blogposts">
            <p> Please add some content to your blogpost blogposts document.</p>
        </div>
        <footer-prismic/>
    </div>
</template>

<script>
    import Project from '../components/Project.vue';
    import SlicesBlock from '../components/SlicesBlock.vue'
    import FooterPrismic from '../components/FooterPrismic.vue'

    export default {
        name: 'blogposts',

        components: {
            Project,
            SlicesBlock,
            FooterPrismic
        },
        data () {
            return {
                documentId: '',
                meta: {
                    seo_title: null,
                    seo_description: null,
                },
                fields: {
                    headline: null,
                    description: null,
                    image: null
                },
                blogposts: [],
                linkResolver: this.$prismic.linkResolver,
                hasContent: false,
                show: false,
            }
        },
        metaInfo () {
            return {
                title: this.meta.seo_title,
                meta: [
                    { vmid: 'description', name: 'description', content: this.meta.seo_description }
                ]
            }
        },
        methods: {
            getContent () {
                //Query to get blogposts content
                this.$prismic.client.getSingle('blogposts')
                    .then((document) => {
                        if (document) {
                            this.documentId = document.id
                            this.fields.headline = document.data.headline;
                            this.fields.description = document.data.description;
                            //this.fields.image = document.data.image.url;
                            this.meta.seo_title = document.data.seo_title;
                            this.meta.seo_description = document.data.seo_description;
                            //Check that the blogposts contains content
                            this.checkForContent();

                            //Set slices as variable
                            this.slices = document.data.body
                        } else {
                            //returns error page
                            this.$router.push({ name: 'not-found' })
                        }
                    })
            },
            //Function to check for any content on the blog post
            checkForContent(){
                if (
                    this.fields.image != undefined ||
                    this.$prismic.richTextAsPlain(this.fields.headline) !== "" ||
                    this.$prismic.richTextAsPlain(this.fields.description) !== ""
                ) {
                    this.hasContent = true;
                }
            },
            scrollToElement() {
                const el = this.$el.getElementsByClassName('blogposts-description')[0];

                if (el) {
                    el.scrollIntoView();
                }
            }
        },
        created () {
            this.getContent()
            window.prismic.setupEditButton();
        }
    }
</script>

<style lang="scss">
    .blogposts {
        width:100%;
        text-align: center;
        margin-top: 100px;
    }
    .blogposts h1.blogposts-title {
        margin: 2rem;
    }
    .blogposts .blogpost-avatar {
        height: 140px;
        width: 140px;
        border-radius: 50%;
        background-position: center;
        background-size: cover;
        margin: 1em auto;
    }
    .blogposts .blogpost-image {
        height: 140px;
        width: 100%;
        background-repeat: no-repeat;
    }
    .blogposts .blogposts-description {
        font-size: 18px;
        color: #9A9A9A;
        line-height: 30px;
    }
    /* Media Queries */
    @media (max-width: 767px) {
        .blogposts {
            padding: 0;
        }
        .blogposts .blogposts-bg {
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            width: 100%;
            height: 10vh;
        }/*
        .blogposts-content {
            position: absolute;
            top: 75vh;
            height: 25vh;
            background: rgba(0,0,0,0.7);
            width: 100%;
            border: 0;
            margin: 0;
        }
        .blogposts-content h1 {
            color: #fff;
            font-size: 65px;
        }
        .blogposts-content .blogposts-description {
            border: 0;
            margin: 0;
            padding-bottom: 1rem;
            color: #fff;
        }*/
        .blogposts-content span.arrow-down {
            color: white;
            font-size: 30px;
        }
    }
</style>
